import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://invoicepoint.app';

export default function PageSEO({ title, description, path, locale }) {
    const canonical = `${BASE_URL}/${locale}${path}`;
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonical} />
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
        </Helmet>
    );
}
